import React from 'react'
import { IconButton, Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

export const BackIconButton = ({ onClick, sx = {} }) => {
    return (
        <IconButton
            onClick={onClick}
            sx={{
                padding: '6px',
                marginLeft: '-8px',
                marginTop: '-8px',
                '&:hover': {
                    backgroundColor: '#F3F4F6',
                },
                ...sx
            }}
        >
            <ArrowBackIcon sx={{ fontSize: '20px', color: '#374151' }} />
        </IconButton>
    )
}

export const BackButton = ({ 
    onClick, 
    text = "Back",
    variant = "outlined",
    sx = {} 
}) => {
    return (
        <Button
            onClick={onClick}
            variant={variant}
            sx={{
                backgroundColor: variant === "outlined" ? "#FFFFFF" : "#1F477D",
                color: variant === "outlined" ? "#374151" : "#FFFFFF",
                padding: '12px 24px',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 500,
                textTransform: 'none',
                minWidth: '120px',
                border: variant === "outlined" ? '1px solid #E5E7EB' : 'none',
                '&:hover': {
                    backgroundColor: variant === "outlined" ? "#F9FAFB" : "#1a3a66",
                    borderColor: variant === "outlined" ? '#D1D5DB' : 'transparent',
                },
                ...sx
            }}
        >
            {text}
        </Button>
    )
}

export const NextButton = ({ 
    onClick, 
    text = "Next",
    disabled = false,
    sx = {} 
}) => {
    return (
        <Button
            onClick={onClick}
            disabled={disabled}
            sx={{
                backgroundColor: disabled ? '#9CA3AF' : '#1F477D',
                color: '#FFFFFF',
                padding: '12px 24px',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 500,
                textTransform: 'none',
                minWidth: '120px',
                '&:hover': {
                    backgroundColor: disabled ? '#9CA3AF' : '#1a3a66',
                },
                '&:disabled': {
                    backgroundColor: '#9CA3AF',
                    color: '#FFFFFF',
                },
                ...sx
            }}
        >
            {text}
        </Button>
    )
} 